import PropTypes from 'prop-types';
import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Card, Box, MenuItem, Stack, RadioGroup, Radio, FormControl, FormControlLabel, Divider, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Scrollbar from '../../components/scrollbar';
import FormProvider, { RHFTextField, RHFSelect } from '../../components/hook-form';
import { PATH_MAIN } from '../../routes/paths';
import UserMasterService from '../../services/userMaster.service';
import ErrormsgPopup from '../../components/modal-popup/errormsgpopup';
import ModalPopup from '../../components/modal-popup/modalpopup';
import CancelButton from '../../components/cancel-button/cancelbutton';
import { handleError } from '../../auth/utils';
// -------------------------------------------------------------------------------------------------------

NewUserModalPopup.propTypes = {
    row: PropTypes.array,
    flag: PropTypes.bool,
    disableFlag: PropTypes.bool,
    confirm: PropTypes.func,
    headerName: PropTypes.string,
    ActiveInActiveUpdate: PropTypes.string,
};
// -------------------------------------------------------------------------------------------------------

export default function NewUserModalPopup({ row, flag, disableFlag, confirm, headerName, ActiveInActiveUpdate }) {

    const navigate = useNavigate();
    const [errormessage, setErrorMessage] = useState("");
    const [errormessagePopup, setErrorMessagePopup] = useState(false);
    const [successmessage, setSuccessMessage] = useState("");
    const [successmessagePopup, setSuccessMessagePopup] = useState(false);
    const [roledata, setRoleData] = useState([]);
    const [disableStatus, setDisableStatus] = useState(false);
    const [selectedUserType, setSelectedUserType] = useState('JJ Connect Dealer');
    const [validationschema, setValidationSchema] = useState('NewJJconnectSchema');
    const [cl, setcl] = useState('0');
    const [selectedId, setSelectedId] = useState();
    const [usernamevar, setusernamevar] = useState('jjconnectdealeruserName');
    const [defValues, setDefValues] = useState([]);
    const [distcodename, setDistcodename] = useState('');
    const [submitstatus, setsubmitstatus] = useState(false);

    const contentList = useMemo(
        () => [
            { id: 0, name: 'JJ Connect Dealer', disabled: selectedId === 1 || selectedId === 2 },
            { id: 1, name: 'JJ Core Dealer', disabled: selectedId === 0 || selectedId === 2 },
            { id: 2, name: 'J&J Employee', disabled: selectedId === 1 || selectedId === 0 },
        ],
        [selectedId]
    );

    const allSchemas = useMemo(
        () => ({

            NewUserMasterSchema: Yup.object().shape({
                jjcoredealerusername: Yup.string().required('User Email ID is required'),
                firstName: Yup.string().required('First Name is required'),
                lastName: Yup.string().required('Last Name is required'),
                addressLine1: Yup.string().required('Address Line1 is required'),
                jjcoredistributorcode: Yup.string().required('Distributor Code is required'),
                postalCode: Yup.string().required('Postal Code is required')
                    .matches(/^[0-9]+$/, 'Postal Code must be a number'),
                mobileNo: Yup.string().required('Mobile Number is required')
                    .matches(/^[0-9]{10}$/, 'Invalid mobile number'),
            }),
            NewJJconnectSchema: Yup.object().shape({

                jjconnectdealeruserName: Yup.string().required('User Email ID is required'),
                jjconnectdealerfirstName: Yup.string().required('First Name is required'),
                jjconnectdealerlastName: Yup.string().required('Last Name is required'),
                jjconnectdistributorcode: Yup.string().required('Distributor Code is required'),

            }),
            NewJJEmployeeSchema: Yup.object().shape({
                jjemployeeuserName: Yup.string().required('User Email ID is required'),
                jjemployeefirstName: Yup.string().required('First Name is required'),
                jjemployeelastName: Yup.string().required('Last Name is required'),
                wwid: Yup.string().required('WWID is required')
                    .matches(/^[0-9]+$/, 'WWID must be a number'),
                // .matches(/^[0-9]+$/, 'WWID must be an integer'),
                // .test('is-number', 'WWID must be a number', value => !isNaN(value) && /^[0-9]+$/.test(value)),
            })
        }), []);

    const formValues = useMemo(
        () => ({
            jjconnectdealeruserName: row?.userName || '',
            jjemployeeuserName: row?.userName || '',
            jjcoredealerusername: row?.userName || '',
            userType: row?.userType || '',
            jjemployeeuserRole: row?.roleName || '',
            firstName: row?.firstName || '',
            lastName: row?.lastName || '',
            jjconnectdealerfirstName: row?.firstName || '',
            jjconnectdealerlastName: row?.lastName || '',
            jjemployeefirstName: row?.firstName || '',
            jjemployeelastName: row?.lastName || '',
            jjcoredistributorcode: row?.distributorcode || '',
            jjconnectdistributorcode: row?.distributorcode || '',
            orgnization: row?.orgnization || '',
            addressLine1: row?.line1 || '',
            addressLine2: row?.line2 || '',
            postalCode: row?.postalcode || '',
            mobileNo: row?.mobileno || '',
            city: row?.city || '',
            state: row?.state || '',
            wwid: row?.wwid || '',
            primaryEmail: row?.userprimaryEmail || '',
            // department: row.department || '',
        }), [row]);

    const methods = useForm({
        resolver: !flag && yupResolver(allSchemas[validationschema]),
        defaultValues: formValues,

    });

    const {
        watch,
        handleSubmit,
        formState: { isSubmitting, errors },

    } = methods;

    const values = watch();

    const onSubmit = (data) => {
        setsubmitstatus(true);
        if (data[usernamevar] !== "") {
            try {
                if (flag) {
                    const flag1 = row?.userStatus === 'Active' ? 1 : 0;
                    const payloadforserStatus = { flag: flag1, userName: row?.userName }

                    UserMasterService.setuserstatus(payloadforserStatus)
                        .then((inactiveresponse) => {
                            if (inactiveresponse.data === "Success") {
                                setSuccessMessage("Successfully changed  status of user.");
                                setSuccessMessagePopup(true);
                            }
                            else {
                                setErrorMessage(inactiveresponse.data);

                                setErrorMessagePopup(true);
                            }
                            console.log("inactive response", inactiveresponse);
                        })
                        .catch(_error => {

                            // TODO: Handle error and show it to user
                            handleError(_error, navigate, "", "");
                        });
                }
                else {
                    const record = roledata.find(item => item.name === data.jjemployeeuserRole)
                    const roleName = record?.name || 'dealer';
                    const roleID = record?.code || '3';

                    let payload = null;

                    if (selectedUserType.toLowerCase().replace(" ", "") === 'jjcore dealer') {
                        const RegPayload = {
                            firstName: data.firstName, lastName: data.lastName, email: data[usernamevar], organization: "JNJ", department: 'department1', application: 'JJ Core',
                            address: {
                                line1: (data.addressLine1), line2: (data.addressLine2), city: (data.city), regionIsoCode: "36", postalCode: data.postalCode, countryIsoCode: "IN", mobileCountryCode: "91", mobileNumber: data.mobileNo
                            },
                        }

                        payload = {
                            UserName: data[usernamevar], // Fix the field name for JJ Core Dealer
                            FirstName: data.firstName,
                            LastName: data.lastName,
                            UserStatus: 'Active',
                            UserEffectiveActivateDate: new Date(),
                            UserEffectiveDeactivateDate: new Date(),
                            UserType: selectedUserType,
                            UserPrimaryEmail: data[usernamevar],
                            DistributorCode: data.jjcoredistributorcode,
                            RecordDate: new Date(),
                            roleName,
                            roleId: roleID,
                            city: data.city,
                            state: data.state,
                            country: "India",
                            countryisocode: "IN",
                            line1: data.addressLine1,
                            line2: data.addressLine2,
                            postalcode: data.postalCode !== "" ? data.postalCode : 0,
                            region: data.city,
                            regionisocode: "36",
                            mobileno: data.mobileNo,
                            registrationVM: RegPayload,
                        };
                    }
                    else if (selectedUserType.toLowerCase().replace(" ", "") === 'jjconnect dealer') {

                        payload =
                        {
                            UserName: data[usernamevar], // Fix the field name for JJ Core Dealer
                            RecordDate: new Date(),
                            roleName,
                            roleId: roleID,
                            UserStatus: 'Active',
                            UserEffectiveActivateDate: new Date(),
                            UserEffectiveDeactivateDate: new Date(),
                            UserType: selectedUserType,
                            DistributorCode: data.jjconnectdistributorcode,
                            FirstName: data.jjconnectdealerfirstName,
                            LastName: data.jjconnectdealerlastName
                        }
                    }
                    else if (selectedUserType.toLowerCase().replace(" ", "") === 'j&jemployee') {
                        payload =
                        {
                            UserName: data[usernamevar], // Fix the field name for JJ Core Dealer
                            RecordDate: new Date(),
                            roleName,
                            roleId: roleID,
                            UserStatus: 'Active',
                            UserEffectiveActivateDate: new Date(),
                            UserEffectiveDeactivateDate: new Date(),
                            UserType: selectedUserType,
                            wwid: data.wwid !== "" ? data.wwid : 0,
                            FirstName: data.jjemployeefirstName,
                            LastName: data.jjemployeelastName
                        }
                    }

                    if (row !== null && row.userName !== "") {
                        UserMasterService.updateonusermaster(payload)
                            .then((updateresponse) => {
                                if (updateresponse.data === "Success") {
                                    setSuccessMessage("Successfully updated records.");
                                    setSuccessMessagePopup(true);
                                }
                                else {
                                    setErrorMessage(updateresponse.data);
                                    setErrorMessagePopup(true);
                                }
                            })
                            .catch(_error => {
                                if (_error.response.data === "") {
                                    setErrorMessage(_error.message);
                                    setErrorMessagePopup(true);
                                }
                                else {
                                    setErrorMessage(_error.response.data);
                                    setErrorMessagePopup(true);
                                }
                                handleError(_error, navigate, "", "");
                            });
                    }
                    else {
                        UserMasterService.CallInsertAPI(payload)
                            .then((insertresponse) => {
                                if (insertresponse.status === 200) {
                                    setSuccessMessage(insertresponse.data);
                                    setSuccessMessagePopup(true)
                                }
                                else {
                                    setErrorMessage(insertresponse.data);
                                    setErrorMessagePopup(true);
                                }
                            })
                            .catch(_error => {
                                if (_error.response.data.status === 400) {
                                    setErrorMessage(_error.message)
                                    setErrorMessagePopup(true);
                                }
                                else if (_error.response.data === "") {
                                    setErrorMessage(_error.message);
                                    setErrorMessagePopup(true);
                                }
                                else {
                                    setErrorMessage(_error.response.data);
                                    setErrorMessagePopup(true);
                                }
                                // TODO: Handle error and show it to user
                                handleError(_error, navigate, "", "");
                            });
                    }
                }
            }
            catch (error) {
                console.error('error', error);
            }
        }
        setsubmitstatus(false);
    };

    const handleErrormsgConfirm = () => {

        setErrorMessagePopup(false);

    }
    const handleSuccessmsgConfirm = () => {

        window.location.reload();
        setSuccessMessagePopup(false);

    }


    const handleChange = useCallback((event) => {
        setcl(event.target.value);

        if (event.target.value === '0') {
            setSelectedUserType('JJ Connect Dealer');
            setValidationSchema('NewJJconnectSchema');
            setusernamevar('jjconnectdealeruserName');
            setDefValues(formValues);
            setDistcodename('jjconnectdistributorcode');
        }
        else if (event.target.value === '1') {
            setSelectedUserType('JJ Core Dealer');
            setValidationSchema('NewUserMasterSchema');
            setusernamevar('jjcoredealerusername');
            setDefValues(formValues);
            setDistcodename('jjcoredistributorcode');

        }
        else {
            setSelectedUserType('J&J Employee');
            setValidationSchema('NewJJEmployeeSchema');
            setusernamevar('jjemployeeuserName');
            setDefValues(formValues);

        }
    }, [formValues]);

    const onClickNo = () => {
        confirm(false);
    };

    useEffect(() => {

        if (row !== null && row.userName !== "") {
            setDisableStatus(true);
            setSelectedUserType(row.userType)
            let validationSchema = '';

            if (row.userType === 'JJ Connect Dealer') {
                validationSchema = 'NewJJconnectSchema';
            } else if (row.userType === 'JJ Core Dealer') {
                validationSchema = 'NewUserMasterSchema';
            } else if (row.userType === 'J&J Employee') {
                validationSchema = 'NewJJEmployeeSchema';
            }

            setValidationSchema(validationSchema);
            const currentTypeUser = contentList.filter((Item) => Item.name === row.userType);

            setcl(`${currentTypeUser[0].id}`);
            setSelectedId(currentTypeUser[0].id);

        }


    }, [row, contentList])
    useEffect(() => {

        UserMasterService.getroledata()
            .then((response) => {

                if (response.status === 200) {
                    setRoleData(response.data)
                }
                else {
                    // TODO: Handle error and show it to user
                    console.log("error")
                }
            })
            .catch(_error => {
                handleError(_error, navigate, "", "");
            });


    }, [navigate])

    return (
        <div>
            <ModalPopup cancel={onClickNo} title={headerName !== '' ? headerName : 'New User'} sx={{ height: { xs: 530, sm: 530 } }} >
                <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                    <Scrollbar>
                        <Card sx={{ p: 2, width: '100%', height: 425, overflow: 'auto' }}>
                            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                                {headerName === '' ? (<Typography variant='h6' sx={{ mt: 0.8 }}>
                                    Select user type to add:
                                </Typography>) : null}
                                {headerName === '' ? (<FormControl sx={{ mt: 1.5 }}>
                                    <RadioGroup row value={cl} onChange={handleChange}>
                                        {contentList.map((content) => (
                                            <FormControlLabel
                                                key={content.id}
                                                value={content.id}
                                                control={<Radio disabled={content.disabled} />} // Apply the disabled property
                                                label={content.name}
                                            />
                                        ))}
                                    </RadioGroup>
                                </FormControl>) : (<Typography variant='h6'>
                                    {selectedUserType}
                                </Typography>)}
                            </Stack>

                            <Divider />

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '20px',
                                    mt: 2,
                                    rowGap: '30px',
                                    columnGap: '30px',
                                    pt: 0.5
                                }}

                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(1, 1fr)',
                                    sm: 'repeat(1, 1fr)',
                                }}
                            >
                                {selectedUserType === 'JJ Connect Dealer' && (
                                    <>
                                        <RHFTextField name="jjconnectdealeruserName" label="User Email ID" sx={{ width: { xs: '200', sm: '450px' } }} size='small' disabled={disableStatus} />
                                        <RHFTextField name="jjconnectdealerfirstName" label="First Name" sx={{ width: { xs: '200', sm: '450px' } }} size='small' disabled={flag} />
                                        <RHFTextField name="jjconnectdealerlastName" label="Last Name" sx={{ width: { xs: '200', sm: '450px' } }} size='small' disabled={flag} />
                                        <RHFTextField name="jjconnectdistributorcode" label="Distributor Code" size="small" sx={{ width: { xs: '200', sm: '450px' } }} disabled={flag} />
                                        <RHFTextField name="jjconnectdealeruserRole" label=" User Role" sx={{ width: { xs: '200', sm: '450px' } }} size='small' value="Dealer" disabled />
                                    </>
                                )}

                                {selectedUserType === 'J&J Employee' && (
                                    <>
                                        <RHFTextField name="jjemployeeuserName" label="User Email ID" sx={{ width: { xs: '200', sm: '450px' } }} size='small' disabled={disableStatus} />
                                        <RHFTextField name="jjemployeefirstName" label="First Name" sx={{ width: { xs: '200', sm: '450px' } }} size='small' disabled={flag} />
                                        <RHFTextField name="jjemployeelastName" label="Last Name" sx={{ width: { xs: '200', sm: '450px' } }} size='small' disabled={flag} />
                                        <RHFTextField name="wwid" label="WWID" size='small' sx={{ width: { xs: '200', sm: '450px' } }} disabled={flag} />
                                        <RHFSelect name="jjemployeeuserRole" label="User Role" size='small' sx={{ width: { xs: '200', sm: '450px' } }} disabled={flag}>
                                            {roledata.map((user) => (
                                                <MenuItem key={user.name} value={user.name}>
                                                    {user.name}
                                                </MenuItem>
                                            ))}
                                        </RHFSelect>
                                    </>
                                )}
                            </Box>
                            {selectedUserType === 'JJ Core Dealer' && (

                                <Box sx={{ pt: 1, overflow: 'auto' }}
                                    rowGap={3}
                                    columnGap={3}
                                    display="grid"
                                    gridTemplateColumns={{
                                        xs: 'repeat(1, 1fr)',
                                        sm: 'repeat(3, 1fr)',

                                    }}
                                >
                                    <>
                                        <RHFTextField name="jjcoredealerusername" label="User Email ID" size='small' disabled={disableStatus} />
                                        <RHFTextField name="firstName" label="First Name" size="small" disabled={disableStatus} />
                                        <RHFTextField name="lastName" label="Last Name" size="small" disabled={disableStatus} />
                                        <RHFTextField name="addressLine1" label=" Address line 1" size='small' disabled={disableStatus} />
                                        <RHFTextField name="addressLine2" label=" Address line 2" size='small' disabled={disableStatus} />
                                        <RHFTextField name="city" label="City" size='small' disabled={disableStatus} />
                                        <RHFTextField name="state" label="State" size='small' disabled={disableStatus} />
                                        <RHFTextField name="postalCode" label="Postal Code" size='small' disabled={disableStatus} />
                                        <RHFTextField name="mobileNo" label="Mobile No" size='small' disabled={disableStatus} />
                                        <RHFTextField name="jjcoredistributorcode" label="Distributor Code" size="small" disabled={flag} />
                                        <RHFTextField name="drole" label="User Role" size="small" value="Dealer" disabled />
                                    </>
                                </Box>
                            )}
                        </Card>
                    </Scrollbar>

                    <Divider />

                    <Box sx={{ position: 'absolute', bottom: 8, right: 16, pt: 2 }} >
                        <CancelButton handleCancel={onClickNo} />
                        <LoadingButton type="submit" variant="contained" loading={isSubmitting} disabled={submitstatus} >
                            {ActiveInActiveUpdate !== '' ? ActiveInActiveUpdate : 'Submit'}
                        </LoadingButton>
                    </Box>
                </FormProvider>
                {errormessagePopup && <ErrormsgPopup confirm={handleErrormsgConfirm} msg={errormessage} header="Error:" />}

                {successmessagePopup && <ErrormsgPopup confirm={handleSuccessmsgConfirm} msg={successmessage} header="Success:" />}
            </ModalPopup>
        </div >
    )
}